import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import "@/utils/rem";
import './assets/css/normalize.css'
import 'animate.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Plugin from "v-fit-columns";
// import Carousel from "ant-design-vue/lib/carousel";
// import "ant-design-vue/dist/antd.css";
// Vue.use(Carousel);
// import Antd from 'ant-design-vue';   //增加
// import 'ant-design-vue/dist/antd.css';
// Vue.use(Antd)  //Vue.use(Button)修改
Vue.use(Plugin);
Vue.use(ElementUI);
Vue.prototype.$baseURL = "";
Vue.prototype.$request = axios.create({})
Vue.config.productionTip = false
// import "amfe-flexible";
import './utils/rem'
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js